module YVR.Search {
	// Cache the jQuery elements.
	const elements = {
		search: $('.yvr-form'),
		button: $('.yvr-search-box__button'),
		input: $('.yvr-search-box__input')
	};

	function main() {
		bindSearchInput();
	}

	/**
	 * Bind the search redirection method to user inputs.
	 */
	function bindSearchInput() {
		// On keyboard enter
		elements.input.on('keyup', e => {
			const code = e.keyCode || e.which;

			if (code === 13) {
				runSearchInput(e);
			}
		});

		// On search button click
		elements.button.on('click', runSearchInput);
	}

	/**
	 * Collect the search term and add it to the end of the search page.
	 */
	function runSearchInput(e) {
		e.preventDefault();

		const url = elements.search.data('action');
		const term = elements.input.val();

		if (url && term) {
			window.location.href = `${url}#q=${encodeURIComponent(term)}`;
		}
	}

	main();
}
